import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export class AllDashboardNotesQuery extends Query<DashboardNoteItem[]> {
    public constructor() {
        super();
    }
}
export class DashboardNoteItem {
    public id: number;
    public content: string;
    public version: string;
}

export class AllDashboardNotesQueryHandlerBase implements QueryHandler<AllDashboardNotesQuery, DashboardNoteItem[]> {
    private static Url = TaggedUrl.join('user/notes', [Tags.Api]);

    public constructor(private readonly $http: HttpService) { }

    public async handleAsync(): Promise<DashboardNoteItem[]> {
        const { data } = await this.$http.get<DashboardNoteItem[]>(AllDashboardNotesQueryHandlerBase.Url);
        return data;
    }
}
